// extracted by mini-css-extract-plugin
export default {"horizontalDivider":"SecurityMain_horizontalDivider__0W0q4"};